export default {
  ADD_TELEFONES_UTEIS(state, telefonesuteis) {
    state.telefonesuteis = [...state.telefonesuteis, ...telefonesuteis]
  },
  SET_TELEFONES_UTEIS(state, telefonesuteis) {
    state.telefonesuteis = telefonesuteis
  },
}
